import * as React from "react"
import {Button} from "react-bootstrap";
import {useBulletPointsQuery} from "../../../../../hooks/useBulletPointsQuery";

interface IProps {
    numberOfBulletPointsToRender?: number
    showViewAllLink?: boolean
}

export const BulletPoints = ({numberOfBulletPointsToRender, showViewAllLink}: IProps) => {
    const {model, onClick} = useBulletPointsQuery();

    const {
        bulletPoints,
        pagination: {pageCount}
    } = model.getBulletPoints(0, numberOfBulletPointsToRender);

    // If there are no bullet points, for this page, return an empty fragment
    if (pageCount < 1) return <></>;

    return (
        <>
            {bulletPoints.map(({ description }, index) => <li key={index}>{description}</li>)}
            {showViewAllLink &&
                <li>
                    <Button variant="link" className="p-0" onClick={onClick}>
                        View All Product Details
                    </Button>
                </li>
            }
        </>
    )
}